import React from 'react'
import * as Sentry from '@sentry/react'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'
import { SENTRY_DSN } from '@/features/backend/config'
import rootStore from '@/app/store'
import { HTTPError } from '@/utils/error'

Sentry.init({
  dsn: SENTRY_DSN,
  release: APP_VERSION,
  integrations: [
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],
  tracesSampleRate: 1.0,
  beforeSend(event, hint) {
    if (hint.originalException instanceof HTTPError) {
      return null
    }

    const { auth, tool, chat } = rootStore

    const loggedInUser = auth.user!

    event.user = {
      ...(event.user ?? {}),
      id: loggedInUser.id,
      email: loggedInUser.email,
    }

    event.tags = {
      ...(event.tags ?? {}),
      role: loggedInUser.role,
      organization: loggedInUser.organization,
    }

    event.contexts = {
      ...(event.contexts ?? {}),
      tool: {
        data: tool.data,
        inputs: tool.inputs,
        generating: tool.generating,
      },
    }

    if (chat.thread) {
      event.tags = {
        ...(event.tags ?? {}),
        thread: chat.thread._id,
      }
    }

    return event
  },
})

export const logAndCapture = (error: Error) => {
  Sentry.captureException(error)
  console.error(error)
}
